import React, { useState } from 'react';
import { PackageIcon } from 'lucide-react';
import BackButton from '../../../components/UI/BackButton';
import { useBookBoxShelf } from './useBookBoxShelf';
import { SearchFilters } from './SearchFilters';
import { CoverCarousel, ItemGrid, BoxInfoModal, BoxHoverCard } from './ItemDisplay';
const BookBoxShelf = () => {
  const {
    category,
    searchTerm,
    setSearchTerm,
    showFilters,
    setShowFilters,
    selectedGenre,
    setSelectedGenre,
    sortOption,
    setSortOption,
    darkMode,
    hoveredItemId,
    setHoveredItemId,
    mousePosition,
    genres,
    sortedItems,
    navigateToCategory,
    navigateToEdit,
    navigate
  } = useBookBoxShelf();
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const tabs = [{
    label: 'All Boxes',
    key: undefined
  }, {
    label: 'Active',
    key: 'active'
  }, {
    label: 'Past Boxes',
    key: 'past'
  }, {
    label: 'Special Editions',
    key: 'special'
  }];
  return <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-8`} data-id="element-17752" data-mp="3nw6atv4h90za">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17753" data-mp="3sswpqf4jpqj4">
        <div className="mb-6" data-id="element-17754" data-mp="qnoh7r3yxbm">
          <div className="mb-3" data-id="element-17755" data-mp="rqhpmbwlbup">
            <BackButton data-id="element-17756" data-mp="5pi7a9p2slvq" />
          </div>
          <h1 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-17757" data-mp="5ogt3wcrjj9s">
            Box Catalog
          </h1>
          <p className={`mt-1 text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-17758" data-mp="ffbhp7dheuye">
            Manage your subscription box offerings
          </p>
        </div>

        <div className={`mb-6 flex space-x-1 overflow-x-auto border-b ${darkMode ? 'border-gray-700' : 'border-gray-300'}`} data-id="element-17759" data-mp="kg7l7jtx8f3a">
          {tabs.map(tab => <button key={tab.label} onClick={() => tab.key ? navigateToCategory(tab.key) : navigate('/bookbox/shelf')} className={`py-2 px-4 font-medium whitespace-nowrap ${category === tab.key ? `border-b-2 border-purple-600 ${darkMode ? 'text-purple-400' : 'text-purple-600'}` : `${darkMode ? 'text-gray-400 hover:text-purple-400' : 'text-gray-600 hover:text-purple-600'}`}`} data-id="element-17760" data-mp="tfcikmtqy2dv">
              {tab.label}
            </button>)}
        </div>

        <SearchFilters searchTerm={searchTerm} setSearchTerm={setSearchTerm} showFilters={showFilters} setShowFilters={setShowFilters} selectedGenre={selectedGenre} setSelectedGenre={setSelectedGenre} sortOption={sortOption} setSortOption={setSortOption} genres={genres} darkMode={darkMode} data-id="element-17761" data-mp="346c3hl2our21" />

        <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-17762" data-mp="1iv2jl9z83hyc">
          {sortedItems.length > 0 ? <ItemGrid items={sortedItems} darkMode={darkMode} onItemClick={item => setSelectedItem(item)} onHoverEnter={id => !isMobile && setHoveredItemId(id)} onHoverLeave={() => setHoveredItemId(null)} aspectClass="aspect-[4/5]" data-id="element-17763" data-mp="3ajuagxxno3h" /> : <div className="text-center py-12" data-id="element-17764" data-mp="3bp1vpztdc5e4">
              <PackageIcon className={`h-12 w-12 ${darkMode ? 'text-gray-600' : 'text-gray-400'} mx-auto mb-4`} data-id="element-17765" data-mp="3gpg5pnej5pes" />
              <h3 className={`text-lg font-medium mb-2 ${darkMode ? 'text-gray-200' : 'text-gray-900'}`} data-id="element-17766" data-mp="32r9mnde8ptz6">
                No boxes found
              </h3>
              <p className={darkMode ? 'text-gray-400' : 'text-gray-500'} data-id="element-17767" data-mp="10zmwfe26a33r">
                Try adjusting your search or filters
              </p>
            </div>}
        </div>
      </div>

      {!isMobile && hoveredItemId && (() => {
      const item = sortedItems.find(i => i.id === hoveredItemId);
      return item ? <BoxHoverCard item={item} darkMode={darkMode} mousePosition={mousePosition} data-id="element-17768" data-mp="6b34ynfbasmo" /> : null;
    })()}

      {selectedItem && <BoxInfoModal item={selectedItem} darkMode={darkMode} onClose={() => setSelectedItem(null)} onEdit={navigateToEdit} data-id="element-17769" data-mp="3tfssqx3vld3a" />}
    </div>;
};
export default BookBoxShelf;